import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { Clock } from 'lucide-react';

export const StatsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="stats" className="px-4 sm:px-6 py-6 bg-card/50" aria-labelledby="stats-heading" ref={ref}>
      <div className="max-w-2xl mx-auto text-center">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-center gap-4 text-center">
            <Clock className="w-8 h-8 text-foreground" />
            <div className="text-3xl sm:text-4xl font-bold text-foreground">30+</div>
            <div className="text-left">
              <div className="text-sm sm:text-base font-semibold text-foreground">minutes saved per interview</div>
              <div className="text-xs sm:text-sm text-muted-foreground">From scattered notes to fast insights</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};